<template>
    <div id="Container_ScheduleBlockingTimesList">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="'Scheduler Blocking Times'" />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="AddBlockingTime"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Name="'btn_add_blocking_time'"
                >
                </MdButton>
            </b-col>
            <b-col md="9" lg="9" sm="12">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="GetAllRes"
                        />

                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="GetAllRes"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="DateFrom"
                    @input="DateFrom = $event"
                    :Id="'DateFrom'"
                    :Type="'date'"
                    :OnPressEnter="GetAllRes"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="DateTo"
                    @input="DateTo = $event"
                    :Id="'DateTo'"
                    :Type="'date'"
                    :OnPressEnter="GetAllRes"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Therapist')"
                    v-bind:Options="TherapistList"
                    v-bind:Model="TherapistVmodel"
                    v-bind:FieldDescription="'employeeName'"
                    v-bind:FieldCode="'employeeCode'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="true"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="ChangeDropDownTherapist"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
              <MdSelect
                v-bind:Label="$tc('Shared.AppointmentType')"
                v-bind:Options="AppoinmentTypeList"
                v-bind:Model="AppoinmentTypeVmodel"
                v-bind:FieldDescription="'description'"
                v-bind:FieldCode="'code'"
                v-bind:Placeholder="selectPlaceholder"
                v-bind:Multiple="true"
                v-bind:RequireEvent="true"
                v-bind:IfUsevalidation="false"
                :Input="ChangeDropDownAppoinmentType"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Status')"
                    v-bind:Options="StatusList"
                    v-bind:Model="StatusVmodel"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="ChangeDropDownStatus"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="mt-3 text-right">
                    <button
                        v-on:click="GetAllRes"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="12" md="12" sm="12" class="mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />

                <b-row>
                    <b-col md="12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :viewIconEvent="viewIconEvent"
                            :deleteIconEvent="RemoveBlocking"
                            v-bind:VisibleDeleteIcon="true"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                            :FieldsDate="fieldsDate"
                        >
                        </MdTable>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import ePharmacyLocationsService from '@/services/epharmacylocation.service';
import CalendarResourcesService from '@/services/calendarresources.service';
import AppoinmentTypeService from '@/services/appointmenttypes.service'
import CalendarResTimeAllocations from '@/services/calendarrestimeallocations.service';
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';

export default {
    name: 'ScheduleBlockingTimesList',
    mixins: [DBFunctions, ShowMessage],

    data() {
        return {
            ItemCodeModel: [],
            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                ItemsList: [],
                favButtonAtion: false
            },
            BaseFields: [
                { key: 'description', sortable: true, label: this.$t('Shared.Description') },
                { key: 'itemCode', sortable: true, label: this.$t('Shared.Code') }
            ],
            fields: [
                {
                    key: 'employeeName',
                    sortable: true,
                    label: this.$tc('Shared.Employee',1),
                    class: 'text-rigth'
                },
                {
                    key: 'subject',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-rigth'
                },
                {
                    key: 'appTypeName',
                    sortable: true,
                    label: this.$tc('Shared.AppointmentType',1),
                    class: 'text-rigth'
                },
                {
                    key: 'startDate',
                    sortable: true,
                    label: this.$t('Shared.datefrom'),
                    class: 'text-rigth'
                },
                {
                    key: 'endDate',
                    sortable: true,
                    label: this.$t('Shared.dateTo'),
                    class: 'text-rigth'
                },
                {
                    key: 'startTime',
                    sortable: true,
                    label: this.$t('Shared.TimeFrom'),
                    class: 'text-rigth',
                },
                {
                    key: 'endTime',
                    sortable: true,
                    label: this.$t('Shared.TimeTo'),
                    class: 'text-rigth'
                },
                {
                    key: 'apptStatus',
                    sortable: true,
                    label: this.$t('Shared.Status'),
                    class: 'text-rigth'
                }
            ],
            fieldsDate: ['receiveddate'],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: null,
            filterOn: [],
            items: [],
            isReadOnly: false,
            isDateFromValid: true,
            isDateToValid: true,
            DateFrom: null,
            DateTo: null,
            ShowMessageIsEmpty: '',
            parameter: {
                SearchCriteria: '',
                DateFrom: null,
                DateTo: null,
                EmployeeCodeList: [],
                AppointmentTypeList: [],
                Status: null,
                PageNumber: 1,
                PageSize: 0,
            },
            pharmacyLocations: [],
            selectPlaceholder: this.$t('Shared.SelectOptions'),
            locationModel: null,
            isReportVisible: false,
            isReportFilterVisible: false,
            recNoToReport: null,
            TherapistList: [],
            TherapistVmodel: '',
            fullParam: {
                PageSize: 0,
                PageNumber: 0
            },
            AppoinmentTypeList: [],
            AppoinmentTypeVmodel: "",
            StatusList: EnumService.BlockingTimesStatus,
            StatusVmodel: ""
        };
    },

    methods: {

        RemoveBlocking(item) {


            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning'
				})
          .then(value => {
            if(value){
                let groupcreationid = item.groupcreationid
                CalendarResTimeAllocations
                    .Delete(groupcreationid)
                    .then(response => {
                        if (response.status == '200') {
                            this.GetAllRes();
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
                }
          })
        },

        ChangeDropDownStatus(status) {
            this.StatusVmodel = status;
            this.parameter.Status = status && status.value ? status.value : null;

            this.GetAllRes();
        },

        ChangeDropDownTherapist(therapists) {
            this.TherapistVmodel = therapists;
            this.parameter.EmployeeCodeList = [];

            var temp = [];
            therapists.forEach(function(e) {
                temp.push(e.employeeCode.trim());
            });
            this.parameter.EmployeeCodeList = temp;

            this.GetAllRes();
        },

        ChangeDropDownAppoinmentType(appttypes){
            this.AppoinmentTypeVmodel = appttypes;
            this.parameter.AppointmentTypeList = [];

            var temp = [];
            appttypes.forEach(function(e) {
                temp.push(e.code.trim());
            })
            this.parameter.AppointmentTypeList = temp;

            this.GetAllRes();
        },

        getAppointmentTypes() {
            AppoinmentTypeService.getListing()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.AppoinmentTypeList = response.data;
                }
              })
              .catch(error => {
                if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
        },

        getEmployees() {
            CalendarResourcesService.getAll(this.fullParam)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.TherapistList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getValuesItems(value) {
            this.ItemCodeModel = value;
            this.parameter.ItemCodeList = value;
            this.currentPage = 1;
            this.GetAllRes();
        },
        ChangeFilter(m) {
            this.modelFilter = m;
        },

        AddBlockingTime() {
            this.$router.push({ name: 'ScheduleBlockingTimesAdd' })
        },

        viewIconEvent(item) {
            this.$router.push({
                name: 'ScheduleBlockingTimesDetails',
                params: { groupcreationid: item.groupcreationid, status: item.status }
            });
        },

        DateFromChange(value) {
            this.parameter.DateFrom = value;
        },

        DateToChange(value) {
            this.parameter.DateTo = value;
        },

        GetAllRes() {
            this.parameter.PageSize = this.perPage;
            this.parameter.DateFrom = this.DateFrom;
            this.parameter.DateTo = this.DateTo;
            this.parameter.PageNumber = this.currentPage;
            CalendarResTimeAllocations
                .getAll(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        this.items.forEach(element => {
                            let { startDate, endDate } = element;
                            if (startDate)
                                element.startDate = Utils.formatterDateToString(startDate);
                            if (endDate)
                                element.endDate = Utils.formatterDateToString(endDate);
                        });

                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onRowSelected() {},

        onFiltered() {},

        showReportFilter() {
            this.isReportFilterVisible = true;
        },

        closeParamRepWindow() {
            this.isReportFilterVisible = false;
            this.isReportVisible = false;
        },

        pageChanged(page) {
            this.currentPage = page;
            this.GetAllRes();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.GetAllRes();
        },

        getPharmacyLocations() {
            const parameter = {
                PageSize: 0,
                PageNumber: 0,
                FilterByEmployee: true
            };

            this.pharmacyLocations = [];
            ePharmacyLocationsService
                .getAll(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.pharmacyLocations = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        ChangeDropDownLocation(values) {
            this.parameter.Location = [];

            /* if (value && value.length > 0) {
                locations = value.map(x => x.code).join(',');
            }*/

            values.forEach(x => {
                this.parameter.Location.push(x.code);
            });

            //  this.parameter.Location = locations;
            this.currentPage = 1;
            this.GetAllRes();
        },

        validate_date_range() {
            return Utils.isDateFromAndDateTo(this.DateFrom, this.DateTo);
        },

        // Método de validación reutilizable
        validateForm() {
            const isValid = this.validate_date_range();

            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;

            // Forzar actualización del componente
            this.$forceUpdate();

            if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), 'error');
                return false;
            }
            return true;
        }
    },

    created() {
        this.getEmployees();
        this.getAppointmentTypes();
        this.GetAllRes();
    },

    mounted() {
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
    }
};
</script>
